import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { EnvelopeSimple, PaperPlaneTilt } from "@phosphor-icons/react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const NewsletterSignup = ({ compact = false }) => {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setSubmitting(true);
    try {
      const res = await axios.post(`${API}/newsletter/subscribe`, { email: email.trim() });
      setDone(true);
      toast.success(res.data.message === "Already subscribed" ? "You're already on the list!" : "You're in! First digest lands Friday.");
    } catch (err) {
      toast.error(err.response?.data?.detail?.[0]?.msg || "Please enter a valid email address");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className={`bg-[#022C22] ${compact ? "py-8" : "py-12"}`} data-testid="newsletter-signup-box">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
          <div>
            <div className="flex items-center gap-2 mb-2">
              <EnvelopeSimple size={20} className="text-[#6EE7B7]" />
              <span className="text-[#6EE7B7] font-mono text-xs uppercase tracking-wider">Free every Friday</span>
            </div>
            <h2 className="font-serif text-2xl sm:text-3xl text-white mb-1">Get the Friday Digest</h2>
            <p className="text-[#A7F3D0] text-sm sm:text-base">
              The week's mart prices, the Mart Report and top farming stories — straight to your inbox.{" "}
              <Link to="/digest" data-testid="digest-preview-link" className="underline text-white hover:text-[#6EE7B7]">
                See a sample
              </Link>
            </p>
          </div>
          {done ? (
            <div className="px-5 py-3 bg-[#0F766E] text-white text-sm font-medium" data-testid="newsletter-success">
              ✓ Subscribed — see you Friday!
            </div>
          ) : (
            <form onSubmit={handleSubscribe} className="flex flex-col sm:flex-row gap-3 w-full lg:w-auto">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@email.com"
                data-testid="newsletter-email-input"
                className="px-4 py-3 bg-white text-[#33302E] text-sm w-full sm:w-80 outline-none border-2 border-transparent focus:border-[#6EE7B7]"
              />
              <button
                type="submit"
                disabled={submitting}
                data-testid="newsletter-subscribe-btn"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-[#0F766E] text-white text-sm font-semibold hover:bg-[#0D6B64] transition-colors disabled:opacity-60"
              >
                {submitting ? "Subscribing..." : "Subscribe free"} <PaperPlaneTilt size={16} />
              </button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
};

export default NewsletterSignup;
